import cls from './CardButton.module.scss'
import {
    CheckIcon,
    CloseIcon,
    CollectionIcon,
    DreamIcon,
    MessageIcon,
} from 'shared/ui/Icon'
import { classNames } from 'shared/lib/classNames/classNames'
import { memo } from 'react'
import React from 'react'

export const CardButton = memo((props) => {
    const { type, action, className, activeButton, currentSpeak, disabled } =
        props

    const buttonEnum = {
        //переделать под enum
        reject: cls.Reject,
        want: cls.Want,
        accept: cls.Accept,
        collections: cls.Collections,
        speak: cls.Speak,
    }

    const iconEnum = {
        reject: CloseIcon,
        want: DreamIcon,
        accept: CheckIcon,
        collections: CollectionIcon,
        speak: MessageIcon,
    }

    const mode = {
        [cls.Active]: activeButton === type,
    }

    const modeIcon = {
        [cls.ActiveSpeak]: currentSpeak,
    }

    const Icon = iconEnum[type]

    return (
        <button
            aria-label={type}
            disabled={disabled}
            className={classNames(cls.Button, mode, [
                buttonEnum[type],
                className,
            ])}
            onClick={action}
        >
            <Icon className={classNames(cls.Icon, modeIcon, [])} />
            {type === 'want' ? <div className={cls.Text}>В мечты</div> : null}
        </button>
    )
})
